import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Chip,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import moment from "moment";
import {
  SOLUTIONS,
  STATUS,
  TEAM_STATUS,
  USER_LOG,
} from "../../utils/constants";
import { findObjectKeyByValue, titleCase, toTitleCase } from "../../utils/main";
import { Preview } from "@mui/icons-material";
import { openModal } from "../../store/actions/modalAction";
import { useDispatch } from "react-redux";
import FilePreviewComponent from "../../components/FilePreviewComponenet";
import { getRepairingTicketStatusByIdApi } from "../../apis/repairing.api";
import { callApiAction } from "../../store/actions/commonAction";
import { CenteredBox } from "../../components/layouts/OneViewBox";

const CustomerInformationUI = ({ Title, Data }) => {
  return (
    <>
      <Box
        sx={{
          height: "auto",
          width: "100%",
          border: "2px solid #1D013B",
          borderRadius: "10px",
        }}
      >
        {Title && (
          <Box
            p={2}
            sx={{
              borderBottom: "1px solid #1D013B",
              backgroundColor: "rgba(29, 1, 59, 0.1)",
            }}
          >
            <Typography variant="h4" color={"#1D013B"}>
              {Title}
            </Typography>
          </Box>
        )}
        <Grid container p={2} md={12}>
          {Data.map(
            (item, index) =>
              !item?.isField && (
                <>
                  <Grid item mt={2} md={3} xs={3} sm={3} key={index}>
                    <Typography fontWeight="bold" variant="h6">
                      {item.label}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    mt={2}
                    md={item.IsFullLine ? 9 : 3}
                    xs={item.IsFullLine ? 9 : 3}
                    sm={item.IsFullLine ? 9 : 3}
                    key={index}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        color: "#808080",
                      }}
                    >
                      {item.isArray && Array.isArray(item.value)
                        ? item.value
                            .map(
                              (str) =>
                                str.charAt(0).toUpperCase() + str.slice(1),
                            )
                            .join(", ")
                        : item.value}
                    </Typography>
                  </Grid>
                </>
              ),
          )}
        </Grid>
      </Box>
    </>
  );
};

const CustomerInformation = ({ id, statusPass }) => {
  const [STATUSWiseData, setSTATUSWiseData] = useState(
    USER_LOG.CUSTOMER_INFORMATION,
  );
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState();

  const dispatch = useDispatch();
  const PreviewImage = (item) => {
    dispatch(openModal(<FilePreviewComponent device_photo={item} />, "sm"));
  };

  const fetchById = useCallback(
    (id) => {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await getRepairingTicketStatusByIdApi({ id }),
          async (response) => {
            setParams((prev) => ({ ...prev, ...response }));
            setLoading(false);
          },
          (err) => {
            setParams((prev) => ({ ...prev, err }));
            setLoading(false);
          },
        ),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  return (
    <>
      <CustomDialog id={"CustomerInformation"} title={`Customer Information`}>
        <ButtonGroup sx={{ flexDirection: "row", width: "100%", mt: 4, mb: 2 }}>
          <Button
            onClick={() => {
              setSTATUSWiseData(USER_LOG.CUSTOMER_INFORMATION);
            }}
            variant={
              STATUSWiseData === USER_LOG.CUSTOMER_INFORMATION
                ? "contained"
                : "outlined"
            }
          >
            <Typography
              variant="body1"
              color={
                STATUSWiseData === USER_LOG.CUSTOMER_INFORMATION
                  ? "white"
                  : "primary"
              }
            >
              {titleCase(
                findObjectKeyByValue(USER_LOG.CUSTOMER_INFORMATION, USER_LOG),
              )}
            </Typography>
          </Button>
          {params?.HistoryData?.length > 0 && (
            <Button
              onClick={() => {
                setSTATUSWiseData(USER_LOG.HISTORY);
              }}
              variant={
                STATUSWiseData === USER_LOG.HISTORY ? "contained" : "outlined"
              }
            >
              <Typography
                variant="body1"
                color={
                  STATUSWiseData === USER_LOG.HISTORY ? "white" : "primary"
                }
              >
                {titleCase(findObjectKeyByValue(USER_LOG.HISTORY, USER_LOG))}
              </Typography>
            </Button>
          )}
          <Button
            onClick={() => {
              setSTATUSWiseData(USER_LOG.USER_LOGS);
            }}
            variant={
              STATUSWiseData === USER_LOG.USER_LOGS ? "contained" : "outlined"
            }
          >
            <Typography
              variant="body1"
              color={
                STATUSWiseData === USER_LOG.USER_LOGS ? "white" : "primary"
              }
            >
              {titleCase(findObjectKeyByValue(USER_LOG.USER_LOGS, USER_LOG))}
            </Typography>
          </Button>
        </ButtonGroup>
        {loading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            {STATUSWiseData === USER_LOG.CUSTOMER_INFORMATION && (
              <>
                <Box mt={2}>
                  <CustomerInformationUI
                    Title={"Customer Details"}
                    Data={[
                      {
                        label: "Customer Name :",
                        value: params?.customer_name
                          ? toTitleCase(params?.customer_name)
                          : "NA",
                      },
                      {
                        label: "Query Created Date :",
                        value: moment(params?.createdAt).format("DD/MM/YYYY"),
                      },
                      {
                        label: "Customer Ticket No :",
                        value: params?.ticket_no ? params?.ticket_no : "NA",
                      },
                      {
                        label: "Customer Phone Number :",
                        value: params?.customer_phone
                          ? params?.customer_phone
                          : "NA",
                      },
                      {
                        label: "Customer Email :",
                        value: params?.customer_email
                          ? params?.customer_email
                          : "NA",
                      },
                      {
                        label: "Product Source :",
                        value: params?.source_id?.title
                          ? params?.source_id?.title
                          : "NA",
                      },
                      {
                        label: "Country :",
                        value: params?.country?.name
                          ? params?.country?.name
                          : "NA",
                      },
                      {
                        label: "State :",
                        value: params?.state?.name ? params?.state?.name : "NA",
                      },
                      {
                        label: "City :",
                        value: params?.city?.name ? params?.city?.name : "NA",
                      },
                    ]}
                  />
                </Box>
                <Box mt={2}>
                  <CustomerInformationUI
                    Title={"Product Problem Details"}
                    Data={[
                      {
                        label: "Name :",
                        value: params?.product_id?.name
                          ? params?.product_id?.name
                          : "NA",
                      },
                      {
                        label: "Device BoxId :",
                        value: params?.box_id ? params?.box_id : "NA",
                      },
                      {
                        label: "Mode Of Query Solving :",
                        value:
                          params?.solved_in === SOLUTIONS.CALL ||
                          params?.solved_in === SOLUTIONS.Videao_Call
                            ? `Solved In ${toTitleCase(findObjectKeyByValue(params?.solved_in, SOLUTIONS))}`
                            : params?.device_is === "Replace"
                              ? "Replace Device"
                              : statusPass === STATUS.REPAIR_COMPLETED ||
                                  statusPass === STATUS.COMPLETED
                                ? "Repairing Completed"
                                : `In ${toTitleCase(findObjectKeyByValue(params?.solved_in, SOLUTIONS))}`,
                      },
                      {
                        label: "Device Manufacturing Date :",
                        value: params?.manufacturer_date
                          ? moment(params?.manufacturer_date).format(
                              "DD/MM/YYYY",
                            )
                          : "NA",
                      },
                      {
                        label: "Device Photo :",
                        value:
                          params?.device_photo &&
                          params?.device_photo !== "" &&
                          params?.device_photo !== "true" ? (
                            <Preview
                              color="primary"
                              sx={{ cursor: "pointer" }}
                              onClick={() => PreviewImage(params?.device_photo)}
                            >
                              {" "}
                            </Preview>
                          ) : (
                            "NO"
                          ),
                      },
                      {
                        label: "Unbox Device Photo :",
                        value:
                          params?.unbox_photo &&
                          Array.isArray(params?.unbox_photo) &&
                          params?.unbox_photo?.length > 0 &&
                          params?.unbox_photo !== "true"
                            ? params?.unbox_photo.map((item) => (
                                <Preview
                                  color="primary"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => PreviewImage(item)}
                                >
                                  {" "}
                                </Preview>
                              ))
                            : "NO",
                      },
                      {
                        label: "Device Purchase Date :",
                        value: params?.warrenty_date
                          ? moment(params?.warrenty_date).format("DD/MM/YYYY")
                          : "NA",
                        IsFullLine: true,
                      },
                      {
                        label: "Customer Problems :",
                        value: params?.problems.map((item) => (
                          <Typography
                            variant="h6"
                            sx={{
                              border: "1px solid grey",
                              borderRadius: "5px",
                              backgroundColor: "rgba(29, 1, 59, 0.1)",
                              padding: "5px",
                              marginRight: 2,
                            }}
                          >
                            {item}
                          </Typography>
                        )),
                        IsFullLine: true,
                      },
                      {
                        label: "Customer Problems Other :",
                        value: params?.other ? params?.other : "NA",
                        IsFullLine: true,
                        isField: !params?.other,
                      },
                    ]}
                  />
                </Box>
                <Box mt={2}>
                  <CustomerInformationUI
                    Title={
                      statusPass === STATUS.NOT_DISPATCH
                        ? "Dispatch Details"
                        : params?.device_is === "Repairable" ||
                            params?.device_is === "physical_damage"
                          ? "Repair Details"
                          : params?.device_is === "Replace"
                            ? " Replace Details"
                            : "Details View"
                    }
                    Data={[
                      {
                        label: "Query Status :",
                        value: `${toTitleCase(findObjectKeyByValue(params?.status[0].status_role, STATUS))} ( ${toTitleCase(findObjectKeyByValue(params?.status[0].role, TEAM_STATUS))} )`,
                        IsFullLine: true,
                      },
                      {
                        label: "Product Accessories :",
                        value: params?.product_accessories?.map(
                          (item, index) => (
                            <Chip
                              key={index}
                              label={item}
                              variant="outlined"
                              sx={{
                                backgroundColor: "rgba(29, 1, 59, 0.1)",
                                borderColor: "grey",
                                color: "#808080",
                                fontWeight: "bold",
                              }}
                            />
                          ),
                        ),
                        IsFullLine: true,
                        isField: !(params?.product_accessories?.length > 0),
                      },
                      {
                        label: "Customer Device Status :",
                        value: params?.completed_status
                          ? params?.completed_status
                          : "NA",
                        isField: !params?.completed_status,
                      },
                      {
                        label: "Payment Status :",
                        value: params?.repairing_amount_status
                          ? titleCase(params?.repairing_amount_status)
                          : "NA",
                        isField: !params?.repairing_amount_status,
                      },
                      {
                        label: "Before Repair Device Photo :",
                        value:
                          params?.before_photo &&
                          params?.before_photo !== "" &&
                          params?.before_photo !== "true" ? (
                            <Preview
                              color="primary"
                              sx={{ cursor: "pointer" }}
                              onClick={() => PreviewImage(params?.before_photo)}
                            >
                              {" "}
                            </Preview>
                          ) : (
                            "NO"
                          ),
                      },
                      {
                        label: "After Repair Device Photo :",
                        value:
                          params?.after_photo &&
                          Array.isArray(params?.after_photo) &&
                          params?.after_photo?.length > 0 &&
                          params?.after_photo !== "true"
                            ? params?.after_photo.map((item) => (
                                <Preview
                                  color="primary"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => PreviewImage(item)}
                                >
                                  {" "}
                                </Preview>
                              ))
                            : "NO",
                      },
                      {
                        label: "Cancel Payment Remark :",
                        value: params?.dispatch_remarks
                          ? titleCase(params?.dispatch_remarks)
                          : "NA",
                        isField: !params?.dispatch_remarks,
                      },
                      {
                        label: "Courier Partner Name :",
                        value: params?.courier_partner_nmae
                          ? titleCase(params?.courier_partner_nmae)
                          : "NA",
                        isField: !params?.courier_partner_nmae,
                      },
                      {
                        label: "Device Tracking Id :",
                        value: params?.tracking_id
                          ? titleCase(params?.tracking_id)
                          : "NA",
                        isField: !params?.tracking_id,
                      },
                      {
                        label: "Device type Problem :",
                        value: params?.device_is
                          ? titleCase(params?.device_is)
                          : "NA",
                        isField: !params?.device_is,
                      },
                      {
                        label: "Physical Damage Part :",
                        isArray: true,
                        value: params?.physical_damage?.damage_part
                          ? params?.physical_damage?.damage_part
                          : "NA",
                        isField: !(
                          params?.physical_damage?.damage_part?.length > 0 &&
                          params?.physical_damage?.damage_part[0] !== ""
                        ),
                      },
                      {
                        label: "Physical Damage Remarks :",
                        value: params?.physical_damage?.remarks
                          ? params?.physical_damage?.remarks
                          : "NA",
                        isField: !params?.physical_damage?.remarks,
                      },
                      {
                        label: "Physical Damage Amount :",
                        value: params?.physical_damage?.repairing_amount
                          ? params?.physical_damage?.repairing_amount
                          : "NA",
                        isField: !params?.physical_damage?.repairing_amount,
                      },
                      {
                        label: "Repairable Part :",
                        isArray: true,
                        value: params?.repairable_part
                          ? params?.repairable_part
                          : "NA",
                        isField: !(
                          params?.repairable_part?.length > 0 &&
                          params?.repairable_part[0] !== ""
                        ),
                      },
                      {
                        label: "Repairable Remark :",
                        value: params?.repairable_remarks
                          ? params?.repairable_remarks
                          : "NA",
                        isField: !params?.repairable_remarks,
                      },
                      {
                        label: "Repairing Amount :",
                        value: params?.repairing_amount
                          ? params?.repairing_amount
                          : "NA",
                        isField: !params?.repairing_amount,
                      },
                      {
                        label: "Replace Remark :",
                        value: params?.replace_remarks
                          ? params?.replace_remarks
                          : "NA",
                        isField: !params?.replace_remarks,
                      },
                      {
                        label: "New Box Id :",
                        value: params?.new_box_id ? params?.new_box_id : "NA",
                        isField: !params?.new_box_id,
                      },
                      {
                        label: "New Head Set Id :",
                        value: params?.head_set_id ? params?.head_set_id : "NA",
                        isField: !params?.head_set_id,
                      },
                      {
                        label: "Old Band Id :",
                        value: params?.band_box_id ? params?.band_box_id : "NA",
                        isField: !params?.band_box_id,
                      },
                      {
                        label: "New Band Id :",
                        value: params?.new_band_box_id
                          ? params?.new_band_box_id
                          : "NA",
                        isField: !params?.new_band_box_id,
                      },
                    ]}
                  />
                </Box>
              </>
            )}
            {STATUSWiseData === USER_LOG.HISTORY && (
              <>
                {params.HistoryData.map((item) => (
                  <Box mb={2}>
                    <CustomerInformationUI
                      Data={[
                        {
                          label: "Query Created Date :",
                          value: moment(item?.createdAt).format("DD/MM/YYYY"),
                        },
                        {
                          label: "Customer Ticket No :",
                          value: item?.ticket_no ? item?.ticket_no : "NA",
                        },
                        {
                          label: "Customer Problems :",
                          value: item?.problems.map((item) => (
                            <Typography
                              variant="h6"
                              sx={{
                                border: "1px solid grey",
                                borderRadius: "5px",
                                backgroundColor: "rgba(29, 1, 59, 0.1)",
                                padding: "5px",
                                marginRight: 2,
                              }}
                            >
                              {item}
                            </Typography>
                          )),
                          IsFullLine: true,
                        },
                        {
                          label: "Customer Problems Other :",
                          value: item?.other ? item?.other : "NA",
                          IsFullLine: true,
                          isField: !item?.other,
                        },
                        {
                          label: "Mode Of Query Solving :",
                          value:
                            item?.solved_in === SOLUTIONS.CALL ||
                            item?.solved_in === SOLUTIONS.Videao_Call
                              ? `Solved In ${toTitleCase(findObjectKeyByValue(item?.solved_in, SOLUTIONS))}`
                              : item?.device_is === "Replace"
                                ? "Replace Device"
                                : statusPass === STATUS.REPAIR_COMPLETED ||
                                    statusPass === STATUS.COMPLETED
                                  ? "Repairing Completed"
                                  : `In ${toTitleCase(findObjectKeyByValue(item?.solved_in, SOLUTIONS))}`,
                        },
                       
                        {
                          label: "Payment Status :",
                          value: item?.repairing_amount_status
                            ? titleCase(item?.repairing_amount_status)
                            : "NA",
                          isField: !item?.repairing_amount_status,
                        },
                        {
                          label: "Cancel Payment Remark :",
                          value: item?.dispatch_remarks
                            ? titleCase(item?.dispatch_remarks)
                            : "NA",
                          isField: !item?.dispatch_remarks,
                        },
                        {
                          label: "Device type Problem :",
                          value: item?.device_is
                            ? titleCase(item?.device_is)
                            : "NA",
                          isField: !item?.device_is,
                        },
                        {
                          label: "Physical Damage Part :",
                          isArray: true,
                          value: item?.physical_damage?.damage_part
                            ? item?.physical_damage?.damage_part
                            : "NA",
                          isField: !(
                            item?.physical_damage?.damage_part?.length > 0 &&
                            item?.physical_damage?.damage_part[0] !== ""
                          ),
                        },
                        {
                          label: "Physical Damage Remarks :",
                          value: item?.physical_damage?.remarks
                            ? item?.physical_damage?.remarks
                            : "NA",
                          isField: !item?.physical_damage?.remarks,
                        },
                        {
                          label: "Physical Damage Amount :",
                          value: item?.physical_damage?.repairing_amount
                            ? item?.physical_damage?.repairing_amount
                            : "NA",
                          isField: !item?.physical_damage?.repairing_amount,
                        },
                        {
                          label: "Repairable Part :",
                          isArray: true,
                          value: item?.repairable_part
                            ? item?.repairable_part
                            : "NA",
                          isField: !(
                            item?.repairable_part?.length > 0 &&
                            item?.repairable_part[0] !== ""
                          ),
                        },
                        {
                          label: "Repairable Remark :",
                          value: item?.repairable_remarks
                            ? item?.repairable_remarks
                            : "NA",
                          isField: !item?.repairable_remarks,
                        },
                        {
                          label: "Repairing Amount :",
                          value: item?.repairing_amount
                            ? item?.repairing_amount
                            : "NA",
                          isField: !item?.repairing_amount,
                        },
                        {
                          label: "Replace Remark :",
                          value: item?.replace_remarks
                            ? item?.replace_remarks
                            : "NA",
                          isField: !item?.replace_remarks,
                        },
                        {
                          label: "New Box Id :",
                          value: item?.new_box_id ? item?.new_box_id : "NA",
                          isField: !item?.new_box_id,
                        },
                        {
                          label: "New Head Set Id :",
                          value: item?.head_set_id ? item?.head_set_id : "NA",
                          isField: !item?.head_set_id,
                        },
                        {
                          label: "Old Band Id :",
                          value: item?.band_box_id ? item?.band_box_id : "NA",
                          isField: !item?.band_box_id,
                        },
                        {
                          label: "New Band Id :",
                          value: item?.new_band_box_id
                            ? item?.new_band_box_id
                            : "NA",
                          isField: !item?.new_band_box_id,
                        },
                      ]}
                    />
                  </Box>
                ))}
              </>
            )}

            {STATUSWiseData === USER_LOG.USER_LOGS && (
              <>
                <Card
                  sx={{
                    marginBottom: 2,
                    padding: 2,
                    backgroundColor: "#1D013B",
                    color: "white",
                  }}
                >
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={4}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Date
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        User Name
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Query Status
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>

                {params?.logs?.length > 0 ? (
                  params.logs.map((item, index) => (
                    <Card key={index} sx={{ marginBottom: 2, padding: 2 }}>
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={4} sx={{ textAlign: "center" }}>
                          <Typography variant="body2">
                            {moment(item?.date).format("DD/MM/YYYY hh:mm A")}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sx={{ textAlign: "center" }}>
                          <Typography variant="body2">
                            {item?.created_by}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography
                            variant="body2"
                            sx={{ textAlign: "center" }}
                          >
                            {titleCase(
                              findObjectKeyByValue(item?.status, STATUS),
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Card>
                  ))
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "10vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography> No Data Found </Typography>
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </CustomDialog>
    </>
  );
};

export default CustomerInformation;
